import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useParams } from "react-router-dom";
import { getItem } from './Model';

export default function ActiveLastBreadcrumb() {
  const params = useParams();
  let currentItem: string | undefined = params?.id ?? 's2'

  const path = [];
  let item = getItem(currentItem);
  path.push(
    <Link underline="hover" color="text.primary" aria-current="page" href={item.id}>
      {item.title}
    </Link>);
  for (var i = 0; i < 2; ++i) {
    currentItem = item.parentId;
    if (currentItem === undefined) {
      break;
    }
    item = getItem(currentItem);
    path.push(
      (<Link underline="hover" color="inherit" href={item.id}>
        {item.title}
      </Link>));
    currentItem = item.parentId;
  }


  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb">
        {path.reverse()}
      </Breadcrumbs>
    </div>
  );
}

